import React from 'react';
import Footer from './Footer';

export default ({ title, haveImg, imgSrc }) => (
  <header className="banner" style={{ position: !haveImg && 'sticky' }}>
    {haveImg && <img src={imgSrc} alt="feature-img" />}

    <div>
      <h1>{title}</h1>
    </div>
    <Footer />
  </header>
);
